import MaestrosScreen from "../../Screen/Desarrollo/Mestros/MestrosScreen";
import ProcesosScreen from "../../Screen/Desarrollo/ProcesosScreen";
import HilazaScreen from "../../Screen/Desarrollo/HilazaScreen";

export const DesarrolloRoutes = [
  {
    path: 'Desarrollo/Maestros',
    permiso: 117,
    element: <MaestrosScreen />,
  },
  {
    path: 'Desarrollo/Procesos',
    permiso: 119,
    element: <ProcesosScreen />,
  },
  {
    path: 'Desarrollo/Hilaza',
    permiso: 127,
    element: <HilazaScreen />,
  },
];

export default DesarrolloRoutes;